<!--巡视检查组件-->
<template>
    <div>
        <!--面包屑导航-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>养殖日志</el-breadcrumb-item>
            <el-breadcrumb-item>巡视检查</el-breadcrumb-item>
        </el-breadcrumb>
        <!--添加养殖日志-->
        <el-button type="primary" icon="el-icon-plus" style="margin-bottom: 15px" @click="add">添加</el-button>
        <el-dialog title="添加巡视检查" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="巡视事件类型" prop="name" :label-width="formLabelWidth">
                <el-select v-model="form.name" placeholder="选择巡视事件类别">
                    <el-option  v-for="item in inspectionNameList" :key="item" :label="item"
                                :value="item"></el-option>
                </el-select>
            </el-form-item>
            <!--<el-form-item label="塘口名称" prop="pound_id" :label-width="formLabelWidth">
                <el-select v-model="form.pound_id" placeholder="选择所属塘口">
                    <el-option  v-for="item in pondNameList" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                </el-select>
            </el-form-item>-->
            <el-form-item label="活动时间" :label-width="formLabelWidth">
                <el-col :span="10">
                    <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.date" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="1">----</el-col>
                <el-col :span="10">
                    <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="form.time" style="width: 100%;"></el-time-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="其他信息" prop="content" :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.content" placeholder="请描述巡视事件具体情况"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeAdd">取 消</el-button>
            <el-button type="primary" @click="inspectionTourTableListAdd('form')">确 定</el-button>
        </div>
    </el-dialog>
        <!--更新巡视检查-->
        <el-dialog title="更新巡视检查" :visible.sync="updateDialogFormVisible">
            <el-form :model="updateForm" :rules="rules" ref="form">
                <el-form-item label="巡视事件类型" prop="name" :label-width="formLabelWidth">
                    <el-select v-model="updateForm.name" placeholder="选择巡视事件类别">
                        <el-option  v-for="item in inspectionNameList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动时间" :label-width="formLabelWidth" prop="time">
                    <el-col :span="10">
                        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="updateForm.date" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1">----</el-col>
                    <el-col :span="10">
                        <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="updateForm.time" style="width: 100%;"></el-time-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="其他信息" prop="content" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="updateForm.content" placeholder="请描述巡视事件具体情况"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeUpdate">取 消</el-button>
                <el-button type="primary" @click="makeHandleUpdate">确 定</el-button>
            </div>
        </el-dialog>
        <!--表格区域-->
        <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
            <el-table-column prop="name" label="名称" align="center"></el-table-column>
            <el-table-column prop="sysTime" label="填写时间" align="center"></el-table-column>
            <el-table-column prop="content" label="日志内容" align="center"></el-table-column>
            <el-table-column width="300" align="center" fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleUpdate(scope.row)" type="primary" icon="el-icon-edit" size="medium">修改</el-button>
                    <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" size="medium">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination background
                       layout="prev, pager, next"
                       :total="total"
                       :current-page="currentPage"
                       :page-size="pageSize"
                       style="text-align: center;margin-top: 10px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentPage" >
        </el-pagination>
    </div>
</template>

<script>
    import request from "../../../http/dialog";

    export default {
        name: "inspectionTour",
        inject: ['reload'],
        data(){
            return{
                /*表格列表数据*/
                tableData: [],
                currentPage: 1, // 初始页
                pageSize: 8 ,//    每页的数据
                total:0,//列表总数
                /*添加弹出表单*/
                form: {
                    name: '', /*巡视事件类型*/
                    pound_id: '', /*塘口名称*/
                    content: '', /*投入品描述信息*/
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                },
                /*更新弹出表单*/
                updateForm: {
                    name: '', /*巡视事件类型*/
                    pound_id: '', /*塘口名称*/
                    content: '', /*投入品描述信息*/
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                },
                sysTime:'', // 更新时间
                formLabelWidth: '120px', //表单宽度
                /*添加弹出表单默认属性为false*/
                dialogFormVisible: false,
                /*更新弹出表单默认属性为false*/
                updateDialogFormVisible: false,
                pondNameList: [],//存放塘口名称数组
                inspectionNameList: [],//存放巡视类别列表
                loading: true, //table区域加载
                rules: {
                    name: [
                        { required: true, message: '请选择巡视事件', trigger: 'change' }
                    ],
                    pound_id: [
                        { required: true, message: '请选择塘口名称', trigger: 'change' }
                    ],
                    time:[{required:true, message:'请输入时间', trigger:'change'}]
                   /* content:[
                        { required: true, message: '请输入其他信息', trigger: 'blur' }
                    ]*/

                }
            }
        },
        methods:{
            /*获取表格列表*/
            async getTableList(){
                let data = {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                let table = await request.inspectionTableList(data)
                this.tableData = table.data.data.list
                this.total = table.data.data.total
                this.loading = false
               // console.log(table);
            },
            // 删除操作
            handleDelete(data) {
               // console.log(data)
                this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let id = data.id
                    // 删除请求
                    request.deleteInspection(id).then(() => { // 异步操作执行完再执行里面的内容
                        // console.log(res);
                        this.reload()// 刷新页面显示最新状态
                        this.$message.success('删除成功!')
                    })
                }).catch(() => {
                    this.$message.info('已取消删除')
                })
            },
            // 更新操作
            handleUpdate(data){
              //  console.log(data);
                this.updateDialogFormVisible = true;
                this.updateForm = data
                this.sysTime = data.sysTime
                /*let sysTime = data.sysTime.split(' ') // 按照空格分隔时间
                // console.log(sysTime);
                this.updateForm.date = sysTime[0]
                this.updateForm.time = sysTime[1]*/
            },
            // 确认更新
            async makeHandleUpdate(){
                this.updateDialogFormVisible = false
                // console.log(this.updateForm);
                let sendData = { /*添加固定收入传入数据*/
                    id:this.updateForm.id,
                    content: this.updateForm.content,/*记录内容*/
                    name : this.updateForm.name,/*巡视事件类型*/
                    pound_id: this.form.pound_id ,/*塘口名称*/
                    /* remark: '火锅', /!*自定义备注*!/*/
                    time: this.sysTime ,/*用户自定义时间this.updateForm.date + ' '+this.updateForm.time*/
                }
                //console.log(sendData);
                if (this.updateForm.date && this.updateForm.time){
                   sendData.time = this.updateForm.date + ' '+this.updateForm.time
                }
                let res = await request.inspectionTableListUpdate(sendData)
                //console.log(res);
                if (res.msg === 'SUCCESS') {
                    this.$message.success('更新成功')
                    this.reload() // 局部刷新这里
                }else {
                    this.$message.info('更新失败')
                }
            },
            closeUpdate () { // 取消更新
                this.updateDialogFormVisible = false
                this.$message.info('取消更新')
            },
            // pageSize改变时触发
            handleSizeChange (size) {
                this.pagesize = size
                //console.log('handleSizeChange')
            },
            // 当前页面改变时触发
            handleCurrentPage (currentPage) {
                //console.log(currentPage)
                this.currentPage = currentPage
                this.getTableList()
                //console.log('handleCurrentPage')
            },
            /*添加巡视检查按钮方法*/
            async add(){
                this.dialogFormVisible = true;
                /*获取用户名传参给获取塘口名称列表请求函数*/
                /*let name = window.sessionStorage.getItem('name')
                let pondList =await request.getPondList(name)
                 console.log(pondList);
                this.pondNameList = pondList.data.data.list*/
                //let inspectionName = await request.inspectionNameList()/*获取巡视类别列表*/
                //console.log(inspectionName);
                // this.inspectionNameList = inspectionName.data.data
            },
            /*获取巡视类别列表*/
            async getInspectionNameList(){
                let inspectionName = await request.inspectionNameList()/*获取巡视类别列表*/
                this.inspectionNameList = inspectionName.data.data
            },
            /*添加巡视检查请求,增加table数据*/
             inspectionTourTableListAdd(form){
               // console.log(this.form);
                this.$refs[form].validate(async(valid) => {
                    if (valid) {
                        this.dialogFormVisible = false
                        let addData = {
                            content: this.form.content,/*记录内容*/
                            name : this.form.name,/*巡视事件类型*/
                            pound_id: this.form.pound_id ,/*塘口名称*/
                           /* remark: '火锅', /!*自定义备注*!/*/
                            time: this.form.date + ' '+this.form.time ,/*用户自定义时间*/
                        }
                        // console.log(addData);
                        let tempAddData = await request.inspectionTableListAdd(addData)
                        //console.log(tempAddData);
                        if (tempAddData.data){
                             this.reload()
                        }
                    } else {
                        //console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 取消添加
            closeAdd(){
                this.dialogFormVisible = false
                this.$message.info('取消添加')
            },
            /*获取塘口列表*/
            async getPondId(){
                let res = await request.getPondList(window.sessionStorage.getItem('name'));
                if(res.data.data.list.length){
                    this.form.cellId = res.data.data.list[0].id;
                }else {
                    this.form.cellId = 0;
                }
            }
        },
        created() {
            this.getTableList();
            this.getPondId()
        },
        mounted() {
            this.getInspectionNameList()/*获取巡视类别列表*/
        }
    }
</script>

<style scoped>
    /*使用深度选择器修改分页器颜色样式*/
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1abc9c;
        color: #FFF;
    }
</style>
